import React from 'react';
import useBreakpoint from 'use-breakpoint';
import BuyButton from './BuyButton';

import panda187Img from './img/friday-panda_187-x2.png';
import panda188Img from './img/friday-panda_188-x2.png';
import panda434Img from './img/friday-panda_434-x2.png';
import panda8839Img from './img/friday-panda_8839-x2.png';
import panda8854Img from './img/friday-panda_8854-x2.png';
import panda5309Img from './img/friday-panda_5309-x2.png';

import './BlockFours.scss';
import Square from './Square';
import { isMobile, MQ } from './Media';

const BlockFours: React.FC = () => {
    const { minWidth } = useBreakpoint(MQ, 'sm');

    const renderBottom = () => {
        return (
            <>
                <img className="panda-434" src={panda434Img} alt="" />
                <div className="text-center button-box">
                    <BuyButton />
                </div>
            </>
        )
    };
    
    const renderDesktop = () => {
        return (
            <div className="block-fours">
                <div>
                    <div className='row g-0'>
                        <div className='col'>
                            <Square color="red">
                                <div className="panda">
                                    <img className="no-height" src={panda8839Img} alt="" />
                                </div>
                            </Square>
                        </div>
                        <div className='col'>
                            <Square color="green"></Square>
                        </div>
                        <div className='col'>
                            <Square color="yellow">
                                <div className="panda">
                                    <img className="no-height" src={panda187Img} alt="" />
                                </div>
                            </Square>
                        </div>
                        <div className='col'>
                            <Square color="orange"></Square>
                        </div>
                    </div>
                    <div className='row g-0'>
                        <div className='col'>
                            <Square color="yellow"></Square>
                        </div>
                        <div className='col'>
                            <Square color="purple">
                                <div className="panda">
                                    <img className="no-height" src={panda8854Img} alt="" />
                                </div>
                            </Square>
                        </div>
                        <div className='col'>
                            <Square color="blue-light"></Square>
                        </div>
                        <div className='col'>
                            <Square color="orange">
                                <div className="panda">
                                    <img className="no-height" src={panda5309Img} alt="" />
                                </div>
                            </Square>
                        </div>
                    </div>
                </div>
                {false && renderBottom()}
            </div>
        );
    };

    const renderMobile = () => {
        return (
            <div className="block-fours">
                <div>
                    <div className='row g-0'>
                        <div className='col'>
                            <Square color="red">
                                <div className="panda">
                                    <img className="no-height" src={panda8839Img} alt="" />
                                </div>
                            </Square>
                        </div>
                        <div className='col'>
                            <Square color="green"></Square>
                        </div>
                        <div className='col'>
                            <Square color="orange">
                                <div className="panda">
                                    <img className="no-height" src={panda5309Img} alt="" />
                                </div>
                            </Square>
                        </div>
                    </div>
                    <div className='row g-0'>
                        <div className='col'>
                            <Square color="yellow"></Square>
                        </div>
                        <div className='col'>
                            <Square color="purple">
                                <div className="panda">
                                    <img className="no-height" src={panda8854Img} alt="" />
                                </div>
                            </Square>
                        </div>
                        <div className='col'>
                            <Square color="blue-light"></Square>
                        </div>
                        
                    </div>
                </div>
            </div>
        );
    };

    return isMobile(minWidth) ? renderMobile() : renderDesktop();
    
};

export default BlockFours;